<template>
  <v-container>
    <v-row>
      <v-col
        class="bordered bg-white"
        cols="6">
        <v-table
          v-if="step"
          class="bottom_table">
          <tbody>
            <tr>
              <td class="wide_col">
                {{
                  $t(
                    "entities.manufacturingStep.fields.manufacturing_scrap_percentage_part"
                  )
                }}
              </td>
              <td class="input_col">
                <CalcOutput
                  :id="nodeId"
                  field="manufacturing_scrap_percentage_part"
                  hide-label
                  width="80" />
              </td>
              <td class="e_per_piece_col">%</td>
            </tr>

            <tr>
              <td class="wide_col">
                {{
                  $t(
                    "entities.manufacturingStep.fields.manufacturing_scrap_costs_own_valueadd_manufacturing_step_part"
                  )
                }}
              </td>
              <td class="input_col">
                <CalcOutput
                  :id="nodeId"
                  field="manufacturing_scrap_costs_own_valueadd_manufacturing_step_part"
                  hide-label
                  width="80" />
              </td>
              <td class="e_per_piece_col">
                {{ $t("units.e_per_piece_long") }}
              </td>
            </tr>

            <tr>
              <td class="wide_col">
                {{
                  $t(
                    "entities.manufacturingStep.fields.manufacturing_scrap_costs_in_valueadd_manufacturing_step_part"
                  )
                }}
              </td>
              <td class="input_col">
                <CalcOutput
                  :id="nodeId"
                  field="manufacturing_scrap_costs_in_valueadd_manufacturing_step_part"
                  hide-label
                  width="80" />
              </td>
              <td class="e_per_piece_col">
                {{ $t("units.e_per_piece_long") }}
              </td>
            </tr>

            <tr>
              <td class="wide_col">
                {{
                  $t(
                    "entities.manufacturingStep.fields.manufacturing_scrap_costs_manufacturing_step_part"
                  )
                }}
              </td>
              <td class="input_col">
                <CalcOutput
                  :id="nodeId"
                  field="manufacturing_scrap_costs_manufacturing_step_part"
                  hide-label
                  width="80" />
              </td>
              <td class="e_per_piece_col">
                {{ $t("units.e_per_piece_long") }}
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-col>
      <v-col cols="6"> &nbsp; </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useSpaceStore } from "../../../../stores/spaceStore";
import CalcOutput from "../../../../components/Elements/CalcOutput.vue";

const spaceStore = useSpaceStore();

const step = ref(null);

const props = defineProps({
  nodeId: {
    type: String,
    required: true
  }
});

onMounted(() => {
  step.value = spaceStore.calculationElements[props.nodeId];
});
</script>

<style scoped lang="scss">
.bottom_table {
  font-size: 85%;

  .wide_col {
    width: 280px;
  }

  .input_col {
    //width: 80px;
    padding: 0 6px !important;

    .v-field__input {
      min-height: 10px !important;
    }
  }

  .e_per_piece_col {
    width: 30px;
    padding: 0 6px !important;
    white-space: nowrap;
  }

  td,
  th {
    border-bottom: none !important;
  }

  .low-height {
    td,
    th {
      height: 40px !important;
    }
  }

  .v-field__input {
    padding: 4px 8px !important;
  }
}
</style>
